<template>
  <div class="body">
    <van-cell-group v-if="isInfo">
      <div v-if="schoolTypeList.length > 0">
        <ul class="kuang mh">
          <li>类型</li>
          <li>建队率</li>
          <li>学校辅导员配备率</li>
        </ul>
        <div class="kuang cnt">
          <ul v-for="(item, index) in schoolTypeNewArr" :key="index">
            <li class="color">{{ format(item.schoolType, 11) }}</li>
            <li class="color">
              {{ format2(item.schoolBuildingTeamNum, item.total) }}
            </li>
            <li class="color">
              {{ format2(item.isBrigadeCounselorNum, item.total) }}
            </li>
          </ul>
        </div>
      </div>
      <div class="kuang">
        <van-cell v-if="area" title="地区" :value="area" />
        <van-cell v-if="squadronNumTotal" title="中队总数" :value="squadronNumTotal" />
        <van-cell
          v-if="squadronCounselorsNumTotal"
          title="中队辅导员总数"
          :value="squadronCounselorsNumTotal + '人'"
        />
        <van-cell
          v-if="youngNumTotal"
          title="少先队员总数"
          :value="youngNumTotal + '人'"
        />
        <van-cell
          v-if="levelSGWDirectorName"
          title="本级少工委主任姓名"
          :value="levelSGWDirectorName"
        />
        <van-cell
          v-if="levelSGWDirectorJob"
          title="本级少工委主任身份"
          :value="format(levelSGWDirectorJob, 7)"
        />
        <van-cell
          v-if="levelSGWDirectorJobOther"
          title="本级少工委主任职务"
          :value="levelSGWDirectorJobOther"
        />
        <van-cell
          v-if="levelSGWDirectorName2"
          title="本级少工委主任姓名"
          :value="levelSGWDirectorName2"
        />
        <van-cell
          v-if="levelSGWDirectorJob2"
          title="本级少工委主任身份"
          :value="format(levelSGWDirectorJob2, 7)"
        />
        <van-cell
          v-if="levelSGWDirectorJobOther2"
          title="本级少工委主任职务"
          :value="levelSGWDirectorJobOther2"
        />
        <van-cell v-if="sdhsj" title="本届少代会召开时间" :value="format(sdhsj, 6)" />
        <van-cell
          v-if="levelCounselors == 1"
          title="是否配备总辅导员"
          :value="format(levelCounselors, 1)"
        />
        <van-cell v-if="levelCounselors == 2" title="未配备少先队总辅导员" value="" />

        <div v-if="levelCounselors == 1">
          <van-cell v-if="name" title="姓名" :value="name" />
          <van-cell v-if="zzmm" title="政治面貌" :value="format(zzmm, 2)" />
          <van-cell v-if="tel" title="手机号" :value="tel" />
          <van-cell v-if="company" title="编制所在单位" :value="format(company, 8)" />
          <van-cell v-if="company == 7" title="其他编制" :value="companyOther" />
          <van-cell
            v-if="administrationLevel"
            title="行政级别"
            :value="format(administrationLevel, 9)"
          />
          <van-cell v-if="postType" title="岗位类型" :value="format(postType, 10)" />
        </div>
      </div>
    </van-cell-group>
    <van-empty v-else description="暂无填写" />
    <nav-bar />
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { getCounselorData } from "@/service/form";
import { format } from "@/common/js/utils";
import { getLocal } from "@/common/js";
import _ from "lodash";
import navBar from "@/components/NavBar";
export default {
  // 总辅
  name: "zf",
  components: {
    navBar,
  },
  setup() {
    const state = reactive({
      administrationLevel: null,
      company: null,
      companyOther: null,
      levelCounselors: null,
      levelSGWDirector: null,
      levelSGWDirectorJob: null,
      levelSGWDirectorJob2: null,
      levelSGWDirectorName: null,
      levelSGWDirectorName2: null,
      levelSGWDirectorJobOther: null,
      levelSGWDirectorJobOther2: null,
      name: null,
      postType: null,
      schoolTypeList: [],
      schoolTypeNewArr: [],
      sdhsj: null,
      squadronCounselorsNumTotal: null,
      squadronNumTotal: null,
      tel: null,
      youngNumTotal: null,
      zzmm: null,
      isInfo: false,
      area: null,
    });

    onMounted(async () => {
      const res = await getCounselorData();
      const area = await getLocal("dsj_area");
      if (area) {
        state.area = area;
      }
      const { code = 0, data } = res;
      if (code == 10000 && data) {
        //   赋值
        const {
          administrationLevel,
          postType,
          company,
          levelCounselors,
          levelSGWDirector,
          levelSGWDirectorJob,
          schoolTypeList,
        } = data;
        if (
          !schoolTypeList &&
          administrationLevel == 0 &&
          postType == 0 &&
          company == 0 &&
          levelCounselors == 0 &&
          levelSGWDirector == 0 &&
          levelSGWDirectorJob == 0
        ) {
          state.isInfo = false;
        } else {
          state.isInfo = true;
        }
        Object.assign(state, data);
        formatSchoolType();
      } else {
        state.isInfo = false;
      }
    });

    // 防抖
    // const _debounce = _.debounce(formatSchoolType, 2000);

    // 保留两位小数
    const format2 = (num, total) => {
      let n = 0;
      n = ((num / total) * 100).toFixed(2);
      return n + "%";
    };

    const formatSchoolType = () => {
      const { schoolTypeList } = state;
      // schoolBuildingTeam  1 建队，2 没， schoolBuildingTeam 对应值是1的 相加 / total 相加 = 建队率
      // total 相加是总数

      const newList = _.groupBy(schoolTypeList, "schoolType");
      let newArr = Object.keys(newList).map((key) => {
        const i = newList[key];

        // 按schoolType分组计算总数total
        const total = _.sumBy(i, function (o) {
          return o.total;
        });

        // 计算建队率 对应值是1的 相加
        const schoolBuildingTeamNum = _.sumBy(i, function (o) {
          return o.schoolBuildingTeam == 1 ? o.total : 0;
        });

        // 辅导员配备率情况
        // TODO 辅导员配备率 = isBrigadeCounselorNum / total - (schoolBuildingTeam == 2)的情况
        // 目前基数是同一个total
        const isBrigadeCounselorNum = _.sumBy(i, function (o) {
          return o.isBrigadeCounselor == 1 ? o.total : 0;
        });

        return {
          isBrigadeCounselorNum,
          schoolBuildingTeamNum,
          schoolType: i[0].schoolType,
          total,
        };
      });
      state.schoolTypeNewArr = newArr;
    };

    return {
      ...toRefs(state),
      format,
      format2,
    };
  },
};
</script>
<style lang="less" scoped>
.body {
  // background: #fff;
  padding-bottom: 1.2rem;
}
.mh {
  min-height: 0.8rem !important;
  border-radius: 0 !important;
  align-items: center;
  padding: 0.4rem 0.4rem 0.1rem 0.4rem;
  margin: 0;
  font-size: 0.373rem;
}
ul {
  display: flex;
}
ul li {
  text-align: center;
  border-bottom: #dcdcdc;
  flex: 1;
}
ul li.color {
  color: #969799;
}
.cnt {
  margin-top: 0.2rem;
}
.cnt ul li {
  padding: 0.31rem;
}
:deep(.van-cell-group) {
  overflow: hidden;
}
</style>
